import { TrackingEvent } from '../types';

// Please update `./README.md` when changing the tracking configuration!

export const submittedContactForm = (): TrackingEvent[] => [{
    category: 'contact',
    action: 'submit - contact form',
    name: 'contact form - general',
}];
